import {
  getReferralReward as publicGetReferralReward,
  queryReferralRewards as publicQueryReferralRewards,
  typedQueryReferralRewards as publicTypedQueryReferralRewards,
  bulkGetReferralRewards as publicBulkGetReferralRewards,
} from './loyalty-referral-v1-referral-reward-rewards.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryReferralRewardsOptions,
  ReferralRewardQuery,
  ReferralRewardsQueryBuilder,
  typedQueryReferralRewards as universalTypedQueryReferralRewards,
} from './loyalty-referral-v1-referral-reward-rewards.universal.js';

function customQueryReferralRewards(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryReferralRewardsOptions) =>
      publicQueryReferralRewards(httpClient)(options),
    typedQueryFunction: (
      query: ReferralRewardQuery,
      options?: QueryReferralRewardsOptions
    ) => publicTypedQueryReferralRewards(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: ReferralRewardQuery,
    options?: QueryReferralRewardsOptions
  ): ReturnType<typeof universalTypedQueryReferralRewards>;
  function overloadedQuery(
    options?: QueryReferralRewardsOptions
  ): ReferralRewardsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: ReferralRewardQuery | QueryReferralRewardsOptions,
    options?: QueryReferralRewardsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getReferralReward: MaybeContext<
  BuildRESTFunction<typeof publicGetReferralReward> &
    typeof publicGetReferralReward
> = /*#__PURE__*/ createRESTModule(publicGetReferralReward);
/** @internal */
export const bulkGetReferralRewards: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetReferralRewards> &
    typeof publicBulkGetReferralRewards
> = /*#__PURE__*/ createRESTModule(publicBulkGetReferralRewards);
export const queryReferralRewards: MaybeContext<
  BuildRESTFunction<typeof customQueryReferralRewards> &
    typeof customQueryReferralRewards
> = /*#__PURE__*/ createRESTModule(customQueryReferralRewards);

export {
  RewardTypeType,
  Status,
  DiscountType,
  SortOrder,
  Type,
  WebhookIdentityType,
} from './loyalty-referral-v1-referral-reward-rewards.universal.js';
export {
  ReferralReward,
  ReferralRewardReceiverOneOf,
  ReferralRewardRewardTypeOptionsOneOf,
  V1Coupon,
  Coupon,
  CouponDiscountTypeOptionsOneOf,
  CouponScopeOrMinSubtotalOneOf,
  FixedAmountDiscount,
  PercentageDiscount,
  CouponScope,
  Group,
  V1LoyaltyPoints,
  GetReferralRewardRequest,
  GetReferralRewardResponse,
  QueryReferralRewardsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryReferralRewardsResponse,
  CursorPagingMetadata,
  Cursors,
  ValidateReferralRewardRequest,
  Reward,
  RewardOptionsOneOf,
  LoyaltyPoints,
  ValidateReferralRewardResponse,
  BulkGetReferralRewardsRequest,
  BulkGetReferralRewardsResponse,
  RewardsInSite,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  SuccessfulReferralEvent,
  ReferredFriendDetails,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  QueryReferralRewardsOptions,
  ReferralRewardsQueryResult,
  ReferralRewardsQueryBuilder,
  ReferralRewardQuerySpec,
} from './loyalty-referral-v1-referral-reward-rewards.universal.js';
export { utils } from './loyalty-referral-v1-referral-reward-rewards.universal.js';
export {
  RewardTypeTypeWithLiterals,
  StatusWithLiterals,
  DiscountTypeWithLiterals,
  SortOrderWithLiterals,
  TypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ReferralRewardQuery,
} from './loyalty-referral-v1-referral-reward-rewards.universal.js';
